<mat-card appearance="outlined">
  <div class="row">
    <div class="col">
      <ng-container *ngIf="response_error == null">
        <p class="text-center"><strong>¿Seguro que quiere eliminar esta inversión?</strong></p>
      </ng-container>
      <ng-container *ngIf="response_message != null">
        <p class="text-center">
          <strong>{{response_message}}</strong>
        </p>
      </ng-container>
      <div class="d-flex justify-content-center flex-column flex-md-row">
        <ng-container *ngIf="response_error == null">
          <button class="me-0 me-md-2 mb-2 mb-md-0" mat-stroked-button (click)="delete()">
            <mat-icon>delete</mat-icon>
            Eliminar
          </button>
        </ng-container>
        <button mat-stroked-button (click)="closeDialog()">
          <mat-icon>close</mat-icon>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</mat-card>
